import type { ReactNode } from 'react';

import { ThemeProvider } from '@emotion/react';

import type { Brand, ThemeConfig, ThemeModes } from './themes';
import { getTheme } from './themes';

type Props = {
  children: ReactNode;
  config?: ThemeConfig;
  brand?: Brand;
  mode?: ThemeModes;
};
export const TestThemeProvider = ({ config, children, brand, mode }: Props) => {
  const defaultConfig = getTheme({ config, brand, mode });

  return <ThemeProvider theme={defaultConfig}>{children}</ThemeProvider>;
};
